import * as Yup from "yup";
const ngoSignUpValidationSchema2 = Yup.object({
  contact_name: Yup.string().required("This field is required"),
  // contact_number: Yup.string()
  //   .matches(/^[0-9]+$/, "Must be only digits")
  //   .min(11, "Must be 11 digits")
  //   .max(11, "Must be 11 digits")
  //   .required("This field is Required"),
  contact_email: Yup.string()
    .email("Please enter a valid email")
    .required("This field is required"),
});

export { ngoSignUpValidationSchema2 };
